import { createRoot } from "react-dom/client";
import { App } from "./App";
import injectCSS from "./injectCSS";

injectCSS().then(() => {
  const container = document.getElementById("entuitive-widget");
  const root = createRoot(container);
  root.render(<App />);
});
